import { create } from 'zustand';

interface SignUpForm {
  email: string;
  password: string;
}

const initialForm: SignUpForm = {
  email: '',
  password: '',
};

interface SignUpStore {
  isSubmitting: boolean;
  form: SignUpForm;
  setIsSubmitting: (isSubmitting: boolean) => void;
  setForm: (form: Partial<SignUpForm>) => void;
  reset: () => void;
}

export const useSignUpStore = create<SignUpStore>((set, get) => ({
  isSubmitting: false,
  form: initialForm,
  setIsSubmitting: (isSubmitting) => set({ isSubmitting }),
  setForm: (updates) => set({ form: { ...get().form, ...updates } }),
  reset: () => set({ isSubmitting: false, form: initialForm }),
}));
